<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '140px'">
      <el-form-item label="短信编码" prop="smsNumber">
          <el-input v-model="dataForm.smsNumber" placeholder="短信编码"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
      <el-form-item label="平台" prop="platform">
          <el-radio v-model="dataForm.platform" label="阿里云">阿里云</el-radio>
          <el-radio v-model="dataForm.platform" label="大汉三通">大汉三通</el-radio>
          <el-radio v-model="dataForm.platform" label="腾讯云">腾讯云</el-radio>
          <el-radio v-model="dataForm.platform" label="七牛">七牛</el-radio>
      </el-form-item>
          <el-form-item label="accessKey" prop="accessKey">
          <el-input v-model="dataForm.accessKey" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="accessSecret" prop="accessSecret">
          <el-input v-model="dataForm.accessSecret" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="短信签名" prop="signName">
          <el-input v-model="dataForm.signName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="短信模板" prop="templateCode">
          <el-input v-model="dataForm.templateCode" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="域名" prop="domainName">
          <el-input v-model="dataForm.domainName" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
          <el-select v-model="dataForm.status" placeholder="请选择">
            <el-option 
              v-for="item in statusList" 
              :key="item.value"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
      </el-form-item>
      
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      statusList:[
        {
          label: '禁用',
          value: 0,
        },
        {
          label: '启用',
          value: 1,
        },
      ],
      dataForm: {
        id: '',
        smsNumber: '',
        remark: '',
        platform: '',
        accessKey: '',
        accessSecret: '',
        signName: '',
        templateCode: '',
        status: '',
        creator: '',
        createDate: '',
        updateTime: '',
        domainName: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        domainName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        smsNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        platform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessKey: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        accessSecret: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        signName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        templateCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/smscontrol/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/smscontrol/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
